(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geotiff-elevation", [], factory);
	else if(typeof exports === 'object')
		exports["geotiff-elevation"] = factory();
	else
		root["geotiff-elevation"] = factory();
})(self, function() {
return 